// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ErrorPage_wrap__st7bX","code":"ErrorPage_code__6VYZF","placeholder":"ErrorPage_placeholder__BcUJd","video":"ErrorPage_video__Bl811"};